(function () {
    'use strict';

    angular
        .module('tyallsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app.account.requestReset', {
            // parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                '@app': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
